import { render, staticRenderFns } from "./DeleteTraining.vue?vue&type=template&id=4453be70"
import script from "./DeleteTraining.vue?vue&type=script&lang=js"
export * from "./DeleteTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports